import request from "@/utils/request";

//获取角色列表
export async function roleList(data) {
  return request({
    url: "/SysRole/list",
    method: "post",
    data: data,
  });
}

//添加角色
export async function roleAdd(data) {
  return request({
    url: "/SysRole/add",
    method: "post",
    data: data,
  });
}

//编辑角色
export async function roleUpdate(data) {
  return request({
    url: "/SysRole/SetRole",
    method: "post",
    data: data,
  });
}

//删除角色
export async function roleDel(data) {
  return request({
    url: "/SysRole/DeleteRole",
    method: "post",
    data: data,
  });
}

//角色配置权限
export async function roleSet(data) {
  return request({
    url: "/SysRole/setPermission",
    method: "post",
    data: data,
  });
}
